import { connect } from 'react-redux';
import { compose } from 'redux';
import { createAttUpgrade as createUpgradePurchase } from '../actions';
import { updatePlan } from 'subscriptions/att/actions';
import { getAttUpgradePurchase } from 'reducers';
import subscriptionDecorator from 'subscriptions/decorator';
import UpgradePurchase from './UpgradePurchase';

const mapStateToProps = (state, { subId }) => ({
  purchase: getAttUpgradePurchase(state, subId)
});

const mapDispatchToProps = {
  createUpgradePurchase,
  updatePlan,
}

export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(UpgradePurchase);
